import type { ZonedDateTime } from '@internationalized/date';
import { parseZonedDateTime, toLocalTimeZone } from '@internationalized/date';

type Tag<T> = { _tag: T };
export type ZonedDateTimeString =
    | (string & Tag<'ZonedDateTimeString'>)
    | Tag<'ZonedDateTimeString'>;

export function createZonedDateTimeString(str: string): ZonedDateTimeString {
    return str as ZonedDateTimeString;
}

export function toZonedDateTimeString(date: ZonedDateTime): ZonedDateTimeString {
    return createZonedDateTimeString(date.toString());
}

export function toZonedDateTimeStringOrNull(
    date: ZonedDateTime | null,
): ZonedDateTimeString | null {
    return date == null ? null : createZonedDateTimeString(date.toString());
}

export function fromZonedDateTimeString(string: ZonedDateTimeString): ZonedDateTime {
    return parseZonedDateTime(string as string);
}

export function fromZonedDateTimeStringOrNull(
    string: ZonedDateTimeString | null,
): ZonedDateTime | null {
    return parseZonedDateTime(string as string);
}

export function fromZonedDateTimeStringToLocalDate(
    string: ZonedDateTimeString,
): ZonedDateTime {
    return toLocalTimeZone(fromZonedDateTimeString(string));
}

export function fromZonedDateTimeStringToLocalDateOrNull(
    string: ZonedDateTimeString | null,
): ZonedDateTime | null {
    if (string == null) {
        return null;
    }
    return fromZonedDateTimeStringToLocalDate(string);
}
